<template>
  <div :class="$style.icon">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 640 320"
    >
      <g>
        <path
          :class="$style.st0"
          d="M320.9,235.6L281.6,69.1l-88.8-56.5L32.4,50.3c-5.4,1.2-10.4,5.1-14,10.9c-4.2,6.7-5.8,14.7-4.3,21.3
		l50.4,213.6c2.5,10.9,11.8,18.2,22.3,18.2c1.7,0,3.4-0.2,5.1-0.6L302.8,264c6.1-1.4,11.6-5.3,15-10.7
		C321.2,247.9,322.3,241.6,320.9,235.6z M314.4,251.1c-2.9,4.6-7.4,7.8-12.5,9L91,309.9c-10.3,2.3-20.2-4.1-22.6-14.6L18,81.6
		C16.7,76,18.2,69,21.8,63.3c3.1-4.9,7.1-8.1,11.5-9.1L191.6,17l14.1,56.9c2,8.5,9,14,21.2,11.4l51.4-12.9L317,236.6
		C318.1,241.5,317.2,246.6,314.4,251.1z"
        />
        <rect
          :class="$style.st1"
          x="65.1"
          y="124.6"
          transform="matrix(0.9733 -0.2297 0.2297 0.9733 -38.885 45.0203)"
          width="217.5"
          height="129.8"
        />
        <polygon
          :class="$style.st2"
          points="5.5,115.1 171.7,74.9 187.7,143.7 21.5,183.9"
        />
        <polygon
          :class="$style.st3"
          points="37.1,180.2 40.1,192.8 21.5,183.8"
        />
        <g>
          <text
            x="15"
            y="160"
            :class="[$style.text, $style.textLeft]"
          >{{ text1 }}</text>
        </g>
      </g>
      <g>
        <path
          :class="$style.st0"
          d="M602.2,294.5l33.4-167.9l-57.4-88.3L416.7,6.1c-5.4-1.1-11.6,0.3-17.2,4.1c-6.6,4.4-11.4,10.9-12.7,17.6
		l-42.8,215.3c-2.2,11,3.2,21.4,12.7,25.8c1.5,0.7,3.2,1.2,4.9,1.6L574,312.8c6.1,1.3,12.7,0,18.1-3.6
		C597.4,305.7,601,300.5,602.2,294.5z M589.9,305.9c-4.5,3-10,4-15.1,3l-212.5-42.3c-10.3-2.2-16.7-12.1-14.5-22.7l42.8-215.3
		c1.1-5.6,5.4-11.4,11-15.1c4.8-3.2,9.9-4.4,14.2-3.5l159.5,31.8l-10.8,57.6c-1.7,8.6,2.4,16.5,14.6,19.2l52.1,9.6l-32.9,165.4
		C597.3,298.6,594.3,303,589.9,305.9z"
        />
        <rect
          :class="$style.st1"
          x="422.8"
          y="82.7"
          transform="matrix(0.1951 -0.9808 0.9808 0.1951 204.7168 632.4007)"
          class="st1"
          width="129.8"
          height="217.5"
        />
        <polygon
          :class="$style.st2"
          points="365.3,53.9 533.2,86.3 519.2,155.5 351.3,123.1 	"
        />
        <polygon
          :class="$style.st3"
          points="367,126.2 364.5,139 351.4,123 	"
        />
        <g>
          <text
            x="400"
            y="30"
            :class="[$style.text, $style.textRight]"
          >{{ text2 }}</text>
        </g>
      </g>
    </svg>
  </div>
</template>

<script src="./index.js" />
<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/fonts';
@import 'mpl-css/lib/assets/global/functions/index';
.st0{fill: map-get($colors, 'grey');}
.st1{
  fill: map-get($colors, 'grey-white');
  stroke: map-get($colors, 'grey-light');
}
.st2{fill: map-get($colors, 'new-blue');}
.st3{fill: map-get($colors, 'new-blue');} // earlier blue
.st4{fill: map-get($colors, 'white');}
.text {
  fill: map-get($colors, 'grey-white');
  font-family: $mt-regular;
  font-size: rem(40);
  letter-spacing: .05em;
}
.textLeft {
  transform: rotate(-12deg);
}
.textRight {
  transform: rotate(11deg);
}
.icon {
  svg {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    min-width: auto;
  }
}
</style>
